import { render, staticRenderFns } from "./chaturls.vue?vue&type=template&id=60037e28&scoped=true"
import script from "./chaturls.vue?vue&type=script&lang=js"
export * from "./chaturls.vue?vue&type=script&lang=js"
import style0 from "./chaturls.vue?vue&type=style&index=0&id=60037e28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60037e28",
  null
  
)

export default component.exports